import React from 'react'
import { Breadcrumb } from 'semantic-ui-react'

class PathView extends React.Component {
  renderBreadcrumbSections = () => {
    return(
      this.props.paths.map((item, index) => {
        if(index === this.props.paths.length-1) {
          return ([
            <Breadcrumb.Section key={index + item.name}>{item.name}</Breadcrumb.Section>,
          ])
        }else {
            return ([
            <Breadcrumb.Section key={index + item.name}><a href={this.props.paths[index].path}>{item.name}</a></Breadcrumb.Section>,
            <Breadcrumb.Divider key={index +' divider'} />
          ])
        }
      })
    )
  }

  render() {
    return(
      <Breadcrumb>
        {this.renderBreadcrumbSections()}
      </Breadcrumb>
    )
  }
}

export default PathView



// WEBPACK FOOTER //
// ./src/component/PathView.js